import React, { createContext, useContext, useReducer } from "react";

// This function prepares the dataLayer
export const StateContext = createContext();

// The following function will wrap our app and provide the Data layer
export const StateProvider = ({ reducer, initialState, children }) => (
  <StateContext.Provider value={useReducer(reducer, initialState)}>
    {children}
  </StateContext.Provider>
);

// This last function will pull information from the data layer
export const useStateValue = () => useContext(StateContext);